import { render, staticRenderFns } from "./addLooseOrder.vue?vue&type=template&id=1026366c&scoped=true&"
import script from "./addLooseOrder.vue?vue&type=script&lang=js&"
export * from "./addLooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./addLooseOrder.vue?vue&type=style&index=0&id=1026366c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026366c",
  null
  
)

export default component.exports